import { POPUP_TYPES } from "../post-inspection-diy-documentation-tab/constant";
import  Completed from "./images/completed.svg";
import UnderVerification from "./images/under-verification.svg";

import BankPopup from "./bank-popup";
import AcceptPricePopup from "./accept-price-popup";
import DocumentPopup from "./document-popup";
import PickupSchedulePopup from "./pickup-schedule-popup";

export const BANK_POPUP_DETAILS = {
    BANK_VERIFIED: {
        title: "Bank account added successfully",
        image: Completed
    },
    BANK_UNDER_VERIFICATION: {
        title: "Bank account details under verification",
        image: UnderVerification
    }
};

export const RENDER_POPUP_TYPES = {
    [POPUP_TYPES.BANK_ACCOUNT]: {
        component: BankPopup,
        title: ""
    },
    [POPUP_TYPES.SLOT_UNAVAILABLE]: {
        component: AcceptPricePopup,
        title: "You need to accept price to schedule pickup"
    },
    [POPUP_TYPES.DOCUMENTS]: {
        component: DocumentPopup,
        title: "All documents verified successfully"
    },
    [POPUP_TYPES.POST_SCHEDULE]: {
        component: PickupSchedulePopup,
        title: "Car pickup scheduled successfully"
    }
};
